module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Socket-us-1c478c3968592fef86372a1a527949f6.svg";